import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useClientAuth } from '@/hooks/useClientAuth';
import { useAuth } from '@/hooks/useAuth';
import { ClientSelector } from '@/components/client/ClientSelector';
import { Loader2 } from 'lucide-react';

export default function Dashboard() {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();
  const { clients, currentClient, loading: clientLoading, switchClient } = useClientAuth();

  useEffect(() => {
    if (!authLoading && !user) {
      navigate('/espace-client');
      return;
    }

    if (!clientLoading && currentClient) {
      navigate(`/dashboard/${currentClient.slug}`);
    }
  }, [user, currentClient, authLoading, clientLoading, navigate]);

  if (authLoading || clientLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin" />
      </div>
    );
  }

  if (!user) {
    return null; // Redirecting to login
  }

  return (
    <ClientSelector 
      clients={clients} 
      onClientSelect={switchClient}
    />
  );
}